import { RetryQueryAlert } from 'src/components/alerts/RetryQueryAlert';
import { Card } from 'src/components/ui/card';
import { ForecastChart } from 'src/features/forecast/ForecastChart';
import { ForecastLegend } from 'src/features/forecast/ForecastLegend';
import { useForecast } from 'src/features/forecast/hooks/useForecast';
import { ForecastPaginatedProductDetailsContainer } from 'src/features/forecastPaginated/forecastPaginatedDetails/ForecastPaginatedProductDetailsContainer';
import { ForecastPaginatedTableContainer } from 'src/features/forecastPaginated/forecastPaginatedTable/ForecastPaginatedTableContainer';
import { QUERY_KEY_SKU_FORECAST_DATA } from 'src/keys';
import { useSkuDetailQuery } from 'src/services/api/getSkuDetail';

type ForecastProps = {
  sku: string;
};

export function Forecast({ sku }: ForecastProps) {
  const { data, isLoading, error } = useForecast(sku);
  const { data: skuDetail } = useSkuDetailQuery(sku);

  return (
    <>
      {error ? (
        <div className='flex items-center justify-center p-4'>
          <RetryQueryAlert
            isLoading={isLoading}
            queryKey={[QUERY_KEY_SKU_FORECAST_DATA, sku]}
          />
        </div>
      ) : (
        <div className='flex h-[calc(100vh-65px)] w-full flex-col overflow-y-auto overflow-x-hidden p-6'>
          <div className='flex w-full'>
            <ForecastPaginatedProductDetailsContainer fullWidth sku={sku} />
          </div>
          <Card className='relative mt-4 w-full'>
            <ForecastChart
              className='z-10 mt-4 mb-6 -ml-12 h-[32rem] w-[115%] md:mb-0 md:w-[110%] lg:-mb-4 lg:-ml-16'
              data={data || []}
              isNovelty={skuDetail?.is_novelty}
            />
            <ForecastLegend className='right-4 bottom-4 left-4' />
          </Card>
          <Card className='mt-4'>
            <div className='max-h-fit overflow-auto'>
              <ForecastPaginatedTableContainer
                data={data || []}
                editable={false}
                isLoading={isLoading}
                sku={sku}
              />
            </div>
          </Card>
        </div>
      )}
    </>
  );
}
